import * as Yup from "yup";
import FormDef from "../schema/model.json";
import PostServiceApi from "../../../../../../services/post-service";

import Config from "../../../../../../config";

const { OTHER_PROFESSION_ID } = Config;

const buildInitialFormValues = () => {
  return Object.values(FormDef).reduce((values, field) => {
    values[field.fieldName] = field.initialValue ?? "";
    return values;
  }, {});
};

const buildFormValidationSchema = () => {
  return Yup.object().shape({
    [FormDef.ethnicityId.fieldName]: Yup.string().required(
      "Ethnicity is required",
    ),
    [FormDef.religionId.fieldName]: Yup.string().required(
      "Religion is required",
    ),
    [FormDef.caste.fieldName]: Yup.string().notRequired(),
    [FormDef.professionId.fieldName]: Yup.string().notRequired(),
    [FormDef.otherProfession.fieldName]: Yup.string().when(
      [FormDef.professionId.fieldName],
      {
        is: (professionId) => professionId === OTHER_PROFESSION_ID.toString(),
        then: (schema) => schema.required("Other profession is required"),
        otherwise: (schema) => schema.notRequired(),
      },
    ),
    [FormDef.residentCountryCode.fieldName]: Yup.string().required(
      "Resident country is required",
    ),
    [FormDef.additionalInfo.fieldName]: Yup.string().notRequired(),
  });
};

const submitParentInfo = async ({ data, postId }) => {
  try {
    if (data[FormDef.professionId.fieldName] !== OTHER_PROFESSION_ID) {
      delete data[FormDef.otherProfession.fieldName];
    }

    const cleanedData = Object.fromEntries(
      Object.entries(data).filter(([_, value]) => value),
    );

    const response = await PostServiceApi.addParentInfo({
      data: cleanedData,
      postId,
    });
    if (!response.success) {
      throw new Error("Unable to add parent's info");
    }
  } catch (error) {
    throw new Error(error);
  }
};

const addParentInfoDomain = Object.freeze({
  buildInitialFormValues,
  buildFormValidationSchema,
  submitParentInfo,
});

export default addParentInfoDomain;
